<template>
    <div class="splash-container">
      <!-- 显示启动图 -->
      <img :src="splashImage" alt="Splash Screen" class="splash-image" />
      <!-- 显示跳过按钮和倒计时 -->
      <van-button 
        class="skip-button" 
        type="primary" 
        plain
        @click="skipSplash"
      >
        跳过 {{ countdown }}s
      </van-button>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from "vue";
  import splashImage from "@/assets/home.jpg";
  import { defineEmits } from "vue";
  
  // 定义触发的事件
  const emit = defineEmits(['skip-splash']);
  
  // 倒计时秒数
  const countdown = ref(3);
  // 存储定时器 ID
  let timer;
  
  // 跳过启动图
  const skipSplash = () => {
    clearInterval(timer);
    // 触发自定义事件通知父组件隐藏启动图
    emit('skip-splash');
  };
  
  onMounted(() => {
    // 每秒更新一次倒计时
    timer = setInterval(() => {
      if (countdown.value > 0) {
        countdown.value--;
      } else {
        clearInterval(timer);
        skipSplash();
      }
    }, 1000);
  });
  
  onUnmounted(() => {
    clearInterval(timer);
  });
  </script>
  
  <style scoped>
  /* 原有样式保持不变 */
  .splash-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
  }
  
  .splash-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .skip-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10000;
  }
  </style>